import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PersonTypeModel } from '../../models/PersonTypeModel'


export interface PersonTypeState {
    PersonType: PersonTypeModel
    PersonTypeList: PersonTypeModel[]
}

const initialState: PersonTypeState = {
    PersonType: {} as PersonTypeModel,
    PersonTypeList: [],
}

export const PersonTypeSlice = createSlice({
    name: 'personType',
    initialState,
    reducers: {
        setPersonType: (state, action: PayloadAction<PersonTypeModel[]>) => {
            state.PersonTypeList = action.payload
        },
        savePersonType: (state, action: PayloadAction<PersonTypeModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: PersonTypeModel = { Id: 0, Type: room.Type }
                let currentRoom =
                    state.PersonTypeList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.Type = room.Type
                   
            } else {
                room.Id = (Math.max(...state.PersonTypeList.map((c) => c.Id)) || 0) + 1
                state.PersonTypeList.push(room)
            }
        },
        getPersonTypeById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let PersonType: PersonTypeModel = {} as PersonTypeModel
            if (id > 0) {
                let currentPersonType: PersonTypeModel[] = state.PersonTypeList
                PersonType = currentPersonType.find((c) => c.Id === id) || ({} as PersonTypeModel)
            }

            state.PersonType = PersonType
        },
        deletePersonType: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentPersonType: PersonTypeModel[] = state.PersonTypeList
                state.PersonTypeList = currentPersonType.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setPersonType, savePersonType, getPersonTypeById, deletePersonType } =
PersonTypeSlice.actions

export default PersonTypeSlice.reducer
